export const MESSAGER_LOCALE_ZHCHS = {
    yes: 'æ¯',
    no: 'å¦',
    ok: 'ç¡®å®',
    cancel: 'åæ¶',
    title: 'ç³»ç»æç¤º',
    errorTitle: 'éè¯¯æç¤º',
    prompt: {
        fontSize: {
            name:  'å­ä½å¤§å°',
            small: 'å°',
            middle: 'ä¸­',
            big: 'å¤§',
            large: 'ç¹å¤§',
            huge: 'è¶å¤§'
        },
        tips: {
            surplus: 'è¿å¯ä»¥è¾å¥ {0} ä¸ªå­ç¬¦',
            length: 'å·²è¾å¥ {0} ä¸ªå­ç¬¦'
        }
    },
    exception: {
        expand: 'å±å¼',
        collapse: 'æ¶èµ·',
        happend: 'åçæ¶é´',
        detail: 'è¯¦ç»ä¿¡æ¯',
        copy: 'å¤å¶è¯¦ç»ä¿¡æ¯',
        copySuccess: 'å¤å¶æå',
        copyFailed: 'å¤å¶å¤±è´¥',
        roger: 'ç¥éäº'
    }
};
